/** 统一响应信封（接口 1.0 §响应格式） */
export interface Envelope<T> {
  code: number
  /** 后端已拼好的可直接展示文案 —— **不翻译**（沿用 原则） */
  message: string
  data: T
  traceId: string
}

export class ApiError extends Error {
  constructor(
    readonly code: number,
    message: string,
    readonly traceId?: string,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}
